import { render, staticRenderFns } from "./ComFooter.vue?vue&type=template&id=21baab4e&scoped=true&"
import script from "./ComFooter.vue?vue&type=script&lang=js&"
export * from "./ComFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21baab4e",
  null
  
)

export default component.exports